module.exports = "/images/vendor/flag-icon-css/flags/1x1/ba.svg?a9dbadd71245f7d220448c10b6939fd1";